import { DEFAULT_OPTIMIZED_IMAGE_QUERY_PARAMS } from '../consts/image';
import { QUERY_PARAMS_DIVIDER } from '../consts/url';
// Image Delivery API documentation - https://www.contentstack.com/docs/developers/apis/image-delivery-api
export const getOptimizedImgUrl = (imageUrl, queryParams = {}) => {
    if (!imageUrl) {
        return '';
    }
    const [imgUrlWithoutQueryParams, defaultImgQueryParams] = imageUrl.split('?');
    const queryParamsForOptimizationObj = {
        ...DEFAULT_OPTIMIZED_IMAGE_QUERY_PARAMS,
        ...queryParams,
    };
    const queryParamsForOptimization = Object.entries(queryParamsForOptimizationObj).reduce((acc, [key, value]) => {
        if (acc) {
            return `${acc}${QUERY_PARAMS_DIVIDER}${key}=${value}`;
        }
        return `${key}=${value}`;
    }, '');
    if (defaultImgQueryParams) {
        return `${imgUrlWithoutQueryParams}?${defaultImgQueryParams}${QUERY_PARAMS_DIVIDER}${queryParamsForOptimization}`;
    }
    return `${imgUrlWithoutQueryParams}?${queryParamsForOptimization}`;
};
//# sourceMappingURL=image.js.map